import IEmailAccount from "../IEmailAccount";

export interface INotifications {
  push: boolean;
  sms: boolean;
  email: boolean;
}

export interface INotificationsCount {
  push: number;
  sms: number;
  email: number;
  noContact: number;
  noReachable: number;
  notTargeted?: number;
}

export interface ISendProgress {
  expected?: number;
  done?: number;
}

export interface IMedia {
  type: "image" | "video";
  mediaUrl: string;
  thumbnail?: string;
  playPreview?: string;
  playPreviewText?: string;
  uploaded: boolean;
  processed: boolean;
  extension: string;
  defaultMedia?: boolean;
  mmsImageUrl?: string;
  customThumbnail?: boolean;
}

export type PostType = "pending" | "published";
export type NotificationType = "allNotifications" | "sms" | "email" | "push";
export type PostStyle = "onlySms" | "onlyMms" | "news" | "informative";

export type MediaList = { [key: string]: IMedia };
export const editableStatus = ["delivered", "draft", "onhold", "error"];
export const deletableStatus = [...editableStatus, "cancelled"];
export interface IPostSegmentation {
  id: string;
  name: string;
  isDonor: boolean;
}

export interface IPost {
  id: string;
  skipDraft?: boolean;
  createdOn?: number;
  modifiedOn?: number;
  title?: string;
  content?: string;
  styledContent?: string;
  media?: MediaList;
  status:
    | "draft"
    | "processing"
    | "ready"
    | "delivering"
    | "delivered"
    | "cancelled"
    | "scheduled"
    | "uploading"
    | "onhold"
    | "error";
  errorMessage?: string;
  postType: PostStyle;
  projectId?: string;
  authorId?: string;
  publisherId?: string;
  scheduleTime?: number;
  validatePublishTime?: boolean;
  segments?: { [key: string]: boolean };
  segmentsCount?: { [key: string]: number };
  donors?: { [key: string]: boolean };
  excludeSegments?: { [key: string]: boolean };
  excludeDonors?: { [key: string]: boolean };
  targetedDonors?: number;
  disableNotifications?: boolean;
  notifications?: INotifications;
  notificationsCount?: INotificationsCount;
  sendProgress?: ISendProgress;
  extraEmail?: IEmailAccount;
  clickCount?: number;
  shortUrl?: string;
  onlySmsUrl?: string;
  origin?: string;
  isPaused?: boolean;
  giveButtonUrl?: string;
  giveButtonLabel?: string;
  motivationCode?: string;
  donationIds?: { [key: string]: boolean };
  isEmbeddedPost?: boolean;
  isParentPost?: boolean;
  subCharities?: { [key: string]: boolean };
  enableSalutationMessage?: boolean;
  enableUseCharityLogo?: boolean;
}
